module.exports = __webpack_public_path__ + "img/logo.156ab06b.png";